module.exports = __webpack_public_path__ + "img/logo7.8492d0c5.jpg";